import React, { useEffect, useRef, useState } from 'react';
import './SlidingButtonLabel.css';

/** Button label — outgoing slides down, incoming floats in from above. */
export const SlidingButtonLabel: React.FC<{ text: string }> = ({ text }) => {
  const prevRef = useRef(text);
  const [pair, setPair] = useState<{ from: string | null; to: string }>({
    from: null,
    to: text,
  });

  useEffect(() => {
    if (text === prevRef.current) return;
    const from = prevRef.current;
    prevRef.current = text;
    setPair({ from, to: text });
    const timer = window.setTimeout(() => setPair({ from: null, to: text }), 320);
    return () => window.clearTimeout(timer);
  }, [text]);

  return (
    <span className="sliding-button-label">
      {pair.from != null ? (
        <span className="sliding-button-label-line is-exit" aria-hidden="true">
          {pair.from}
        </span>
      ) : null}
      <span className={`sliding-button-label-line${pair.from != null ? ' is-enter' : ''}`}>{pair.to}</span>
    </span>
  );
};
